document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.getElementById('intro-overlay');
  if (!overlay) return;

  const canvas = document.getElementById('intro-canvas');
  const rule = overlay.querySelector('.intro-rule');
  const subtitle = overlay.querySelector('.intro-subtitle');

  let activeTimeouts = [];

  // Helper to safe-register timeouts so they can be cleaned up on replay
  function setSafeTimeout(callback, delay) {
    const id = setTimeout(callback, delay);
    activeTimeouts.push(id);
    return id;
  }

  function clearAllTimeouts() {
    activeTimeouts.forEach(id => clearTimeout(id));
    activeTimeouts = [];
  }

  // Starstuff SVG Path definition
  const starColors = ['#442D1C', '#EBE3DB', '#241B12', '#FAF7F2', '#B59A7C'];

  function generateStopmotionStar(colorIndex) {
    const star = document.createElement('div');
    star.className = 'starstuff-star';
    star.style.color = starColors[colorIndex % starColors.length];
    star.innerHTML = `
      <svg viewBox="0 0 100 100" width="100%" height="100%" fill="currentColor">
        <path d="M50,10 L58,35 L82,25 L68,48 L90,68 L62,65 L68,90 L50,72 L32,90 L38,65 L10,68 L32,48 L18,25 L42,35 Z"/>
      </svg>
    `;
    return star;
  }

  // Run the intro animation timeline (always plays the stopmotion-widen variant)
  function runIntroAnimation(motionType, isPreview) {
    clearAllTimeouts();

    // Reset overlay layout classes and DOM elements
    overlay.style.display = 'flex';
    overlay.style.opacity = '1';
    overlay.classList.remove('is-done', 'is-expanding', 'is-fading-outro', 'has-outro', 'has-physics');
    document.body.style.overflow = 'hidden';

    // Apply specific motion type class (always force stopmotion-widen)
    overlay.className = 'intro-overlay motion-stopmotion-widen';
    if (canvas) canvas.innerHTML = '';

    if (rule) rule.classList.remove('is-visible');
    if (subtitle) subtitle.classList.remove('is-visible');

    // Clean up dynamically injected elements from previous runs
    const prevExpand = overlay.querySelectorAll('.intro-expand-block, .intro-logomark-rise');
    prevExpand.forEach(el => el.remove());

    const wordmarkEl = overlay.querySelector('.intro-wordmark');
    if (wordmarkEl) {
      wordmarkEl.innerHTML = '';
      wordmarkEl.style.opacity = '1';
      wordmarkEl.style.fontSize = '';
      wordmarkEl.style.letterSpacing = '';

      // Character widths map to match Poppins/Cubao proportions and prevent jumpy layout/clipping
      const charWidths = {
        'E': 0.85, 'L': 0.70, 'M': 1.20, 'N': 0.90, 'T': 0.80, ' ': 0.50,
        'O': 0.95, 'F': 0.75, 'Q': 1.10, 'U': 0.90, 'A': 0.90, 'I': 0.45, 'Y': 0.90
      };

      // Build ELEMENT OF QUALITY character spans
      const text = 'ELEMENT OF QUALITY';
      const spans = [];
      text.split('').forEach((ch, idx) => {
        const span = document.createElement('span');
        span.className = 'intro-letter-span';
        
        // Core indices for E L E M E N O Q
        const isCore = [0, 1, 2, 3, 4, 5, 8, 11].includes(idx);

        if (ch === ' ') {
          span.innerHTML = '&nbsp;';
        } else {
          span.textContent = ch;
        }

        // Initial styling
        const w = charWidths[ch] || 0.85;
        if (isCore) {
          span.style.width = w + 'em';
          span.style.opacity = '0';
          if (motionType === 'apple-stagger-physics') {
            const leftHalf = [0, 1, 2, 3].includes(idx);
            span.style.transform = leftHalf ? 'translateX(10px)' : 'translateX(-10px)';
          }
        } else {
          span.style.width = '0em';
          span.style.opacity = '0';
          span.style.transform = 'translateX(-12px)';
        }
        wordmarkEl.appendChild(span);
        spans.push(span);
      });

      // 1. Stars phase: 6 classic stars snapped in sequence
      const starPositions = [
        { top: '32%', left: '22%', size: 32 },
        { top: '28%', left: '70%', size: 24 },
        { top: '68%', left: '26%', size: 28 },
        { top: '62%', left: '70%', size: 20 },
        { top: '20%', left: '48%', size: 22 },
        { top: '74%', left: '52%', size: 30 }
      ];

      starPositions.forEach((pos, index) => {
        const star = generateStopmotionStar(index);
        star.style.top = pos.top;
        star.style.left = pos.left;
        star.style.width = pos.size + 'px';
        star.style.height = pos.size + 'px';
        if (canvas) canvas.appendChild(star);

        setSafeTimeout(() => {
          star.classList.add('is-visible');
        }, index * 120); // 0ms, 120ms, 240ms, 360ms, 480ms, 600ms
      });

      // 2. Core letters E L E M E N O Q snap in frame-by-frame
      const coreSpans = [
        spans[0], // E
        spans[1], // L
        spans[2], // E
        spans[3], // M
        spans[4], // E
        spans[5], // N
        spans[8], // O
        spans[11] // Q
      ];

      coreSpans.forEach((span, index) => {
        setSafeTimeout(() => {
          span.style.opacity = '1';
        }, 800 + index * 120);
      });

      // 3. Smooth ease-out bezier expansion phase
      setSafeTimeout(() => {
        overlay.classList.add('is-expanding');
        
        const isStaggered = motionType.startsWith('apple-stagger');
        const staggerDelay = 35; // ms per letter

        spans.forEach((span, idx) => {
          const isCore = [0, 1, 2, 3, 4, 5, 8, 11].includes(idx);
          const ch = text[idx];
          const targetWidth = charWidths[ch] || 0.85;

          if (!isCore) {
            if (isStaggered) {
              setSafeTimeout(() => {
                span.style.width = targetWidth + 'em';
                span.style.opacity = '1';
                span.style.transform = 'translateX(0)';
              }, idx * staggerDelay);
            } else {
              span.style.width = targetWidth + 'em';
              span.style.opacity = '1';
              span.style.transform = 'translateX(0)';
            }
          } else {
            if (motionType === 'apple-stagger-physics') {
              setSafeTimeout(() => {
                span.style.transform = 'translateX(0)';
              }, idx * 15);
            }
          }
        });
      }, 1800);

      // 4. Cinematic Wide Outro tracking fade-out
      if (motionType === 'apple-stagger-outro' || motionType === 'apple-stagger-physics') {
        setSafeTimeout(() => {
          overlay.classList.add('is-fading-outro');
        }, 2850);
      }

      // Outro
      setSafeTimeout(() => {
        overlay.classList.add('is-done');
        document.body.style.overflow = '';
        if (!isPreview) sessionStorage.setItem('elemenoq_intro_done', '1');
      }, 3400);

      setSafeTimeout(() => {
        overlay.style.display = 'none';
      }, 3800);
    }
  }

  // Bind global replay function so switcher widget can call it
  window.triggerIntroReplay = function (type) {
    runIntroAnimation(type, true);
  };

  // Run initial animation on load (check session state)
  const savedMotion = 'apple-stagger';

  if (sessionStorage.getItem('elemenoq_intro_done')) {
    overlay.classList.add('is-done');
    overlay.style.display = 'none';
  } else {
    runIntroAnimation(savedMotion, false);
  }
});
